//App
 import { CountyContextData, CountyProps } from "../../../../types/county";
import useForm from "../../../hooks/useForm";
import { CountyContext } from "../CountyContainer";
const useCounty = (props: CountyProps) => {
  return useForm<CountyContextData, CountyProps>(CountyContext, props);
};

export default useCounty;
